module.exports = __webpack_public_path__ + "img/tourism-banner-catalogue.df8c226d.svg";